import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

export function renderValueWithPlaceholder<Value = unknown | unknown[]>(placeholder: string) {
    // eslint-disable-next-line react/display-name
    return (value: Value): React.ReactNode => {
        if (Array.isArray(value) && value.length > 0) {
            return value.join(', ');
        }

        if (Array.isArray(value) || !value) {
            return <SelectPlaceholder>{placeholder}</SelectPlaceholder>;
        }

        return value as React.ReactNode;
    };
}

export function SelectPlaceholder(props: TypographyProps<'span'>) {
    return <Typography component="span" color={(theme) => theme.palette.placeholder} {...props} />;
}
